import React,{Component} from 'react';
import "./ProgressDetail.less";
import {NavBar,Toast,ListView,Icon,Modal} from "antd-mobile";
import {connect} from "react-redux";
import {workingDetails} from "../../../../service/pickService";
import {pickColor,pickStatus} from '../../../../common/js/pickCommon';
const head =  require('../../../../common/image/user.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class ProgressDetail extends Component{
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            showModal:false,
            detailData:{}
        }
    };
    componentDidMount() {
        console.log()
        let params = {
            token: this.props.userInfo.token,
            data:{
                id: this.props.location.state.id
            },
        };
        workingDetails(params).then((res) => {
            if(res.data.code == "0000"){
                this.setState({detailData:res.data.data})
            }else if(res.data.code == "1401"){
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }else {
                Toast.info(res.data.msg,3)
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
    number=(id)=>{ 
        window.location.href = "tel://" + id;
    }
    
    render(){
        const detailData = this.state.detailData
        return(
            <div className="progressDetail">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >订单详情</NavBar>
                <div className="content">
                    <div className="head">
                        <div className="carNum"><img src={head} /><span>{detailData.driverName}</span></div>
                        <div>{detailData.carNum}</div>
                    </div>
                    <div  className="title">
                        <div className="status">
                            <div className="orderNum"><span>接站</span><span>订单号：{detailData.orderNum}</span></div>
                            <div style={{color:`${pickColor(detailData.status)}`}}>{pickStatus(detailData.status)}</div>
                        </div>
                        <div className="date"><span>{detailData.estimatedTimeOfDeparture}</span></div>
                        <div className="location"><span><i className="icon iconfont iconchufadi"></i></span>{detailData.startAddress}</div>
                        <div className="location"><span><i className="icon iconfont iconmudedi"></i></span>{detailData.endAddress}</div>
                        <div className="grade"><span>{detailData.carModelName}</span><span>{detailData.carSeatNum}座</span><span>¥{detailData.actualPrice}</span></div>
                        {detailData.status == 4 ? null :<div className="btn" onClick={()=>this.setState({showModal:!this.state.showModal})}>联系乘客</div>}
                    </div>
                    <Modal
                        className="combineBillViewModal"
                        visible={this.state.showModal}
                        transparent
                        maskClosable={false}
                        footer={[{ text: '否', onPress: () => { this.setState({showModal:!this.state.showModal}); } },{ text: '是', onPress: () => { this.setState({showModal:!this.state.showModal});this.number(detailData.phone) } }]}
                    >
                        <div className="modalTitle">
                            <div>是否确认拨打电话？</div>
                            {/*    <span>出于隐私保护，该号码为虚拟号码</span> */}
                        </div>
                    </Modal>     
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/changeRole/Pick/ProgressDetail.js